export const types = {
  OPEN_INDICATOR: 'OPEN_INDICATOR',
  CLOSE_INDICATOR: 'CLOSE_INDICATOR',
};

export const openIndicator = () => ({
  type: types.OPEN_INDICATOR,
});

export const closeIndicator = () => ({
  type: types.CLOSE_INDICATOR,
});

const INIT_STATE = {
  active: false,
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.OPEN_INDICATOR:
      return {
        ...state,
        active: true,
      };
    case types.CLOSE_INDICATOR:
      return {
        ...state,
        active: false,
      };
    default:
      return state;
  }
}

export const getActiveStatus = (state) => state.questionIndicator.active;



// WEBPACK FOOTER //
// ./src/services/redux/questionIndicator.js